import React from "react";
import "./Desk.css";

const Desk = () => {
  return (
    <div className="desk__section">
      <div className="desksec__audit_card">
        <div className="desk__section_cardcntnt">
          <div className="desk__section_ccheading">Audit & Assurance</div>
          <div className="desk__section_ccdesc">
            Small business tax return preparation or Individual tax return
            preparation filing instructions is a core service offered to our
            clients.
          </div>
        </div>
      </div>
      <div className="desksec__advisory_card">
        <div className="desk__section_cardcntnt">
          <div className="desk__section_ccheading">
            Business & Tax Advisory Services
          </div>
        </div>
      </div>
      <div className="desksec__panning_card">
        <div className="desk__section_cardcntnt">
          <div className="desk__section_ccheading">Year-End Tax Planning</div>
        </div>
      </div>
      <div className="desksec__financial_card">
        <div className="desk__section_cardcntnt">
          <div className="desk__section_ccheading">Financial Planning</div>
        </div>
      </div>
    </div>
  );
};

export default Desk;
